import { IDeceased } from '@frontend/deceased/types';
import { useAccountRepository } from '@frontend/repository';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../redux/store';

interface ViewProps {
    dispatch: ReturnType<typeof useAppDispatch>;
    account_id: string | null;
    onCancel: () => void;
    onSubmitSuccess: (deceased: IDeceased) => void;
}

const useDeceasedCreate = (): ViewProps => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { currentAccount } = useAccountRepository();

    const onCancel = () => {
        navigate('/deceased');
    };

    const onSubmitSuccess = (deceased: IDeceased) => {
        navigate(`/accounts/${deceased.account_id}/deceased/${deceased.id}/detail`);
    };

    return {
        dispatch,
        account_id: currentAccount,
        onCancel,
        onSubmitSuccess
    };
};

export default useDeceasedCreate;
